import { Component } from '@angular/core';
import { NgForOf } from '@angular/common';

interface BottomLink {
  title: string,
  link: string,
  prefix: string,
  linkText: string,
}
@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {
  bottomLinksList: BottomLink[] = [
    {
      title: 'Новостройки',
      link: "/novostrojki/",
      prefix: 'newbuilding',
      linkText: 'Перейти к выбору'
    },
    {
      title: 'Вторичка',
      link: "path('ndv_site_resale_main')",
      prefix: 'resale',
      linkText: 'Перейти к выбору'
    },
    {
      title: 'Коммерческая',
      link: "path('ndv_site_commercial_index_')",
      prefix: 'commercial',
      linkText: 'Перейти к выбору'
    },
    {
      title: 'Загородная',
      link: "path('ndv_site_cottage_main')",
      prefix: 'cottage',
      linkText: 'Перейти к выбору'
    },
    {
      title: 'Журнал о недвижимости',
      link: "path('ndv_journal_homepage')",
      prefix: 'journal',
      linkText: 'Читать'
    },
    {
      title: 'Ипотека on-line',
      link: "path('ndv_site_mortgage_index')",
      prefix: 'mortgage',
      linkText: 'Узнать больше'
    },
  ]
}
